<div class="source-dest-tooltip mat-card">
    <ul>
        <li *ngFor="let size of sizes">
            {{size.product_size}} - {{size.inner_carton_qty}}
        </li>
    </ul>
</div>